module.exports = __webpack_public_path__ + "img/full_service_icon.9a8d30e3.png";